import { VueConstructor } from 'vue';

import { trlMessage } from '@/services/i18n';
import { appConfig } from '@/services/config/app-config';

export interface I18NOptions {
  messages?: Partial<Record<'ru' | 'en', Record<string, string>>>;
  lang?: 'ru' | 'en';
}

function VueL10n(options: I18NOptions) {
  this._options = options;
}

function install(
  Vue: VueConstructor,
  { lang = appConfig.get('lang'), messages = { ru: {}, en: {} } }: I18NOptions = {}
) {
  function $trlMessage(message: string, payload?: Record<string, unknown>, defaultValue = message) {
    // eslint-disable-next-line no-restricted-syntax
    return trlMessage(message, payload, defaultValue, lang, {}, messages[lang]);
  }

  Vue.mixin({
    provide() {
      return {
        $trlMessage
      };
    }
  });

  Vue.prototype.$trlMessage = $trlMessage;
}

VueL10n.install = install;

export default VueL10n;
